<template>
  <div>
    <base-header class="pb-6 pb-8 pt-5 pt-md-8 bg-vg-gradient">
      <div class="row">
        <div class="col-xl-3 col-lg-6 ">
          <router-link :to="{ path: '/jobs'}">
            <stats-card :title="variables.get('job')"
                        cardBg="bg-vg-green"
                        :sub-title="statistics.allJobCount.toString()"
                        icon="ni ni-briefcase-24"
                        class="mb-4 mb-xl-0"
                        v-loading="loading">
            </stats-card>
          </router-link>
        </div>
        <div class="col-xl-3 col-lg-6">
          <router-link :to="{ path: '/jobs'}">
            <stats-card :title="variables.get('application')"
                        cardBg="bg-vg-purple"
                        :sub-title="statistics.applicationCount.toLocaleString()"
                        icon="ni ni-badge"
                        class="mb-4 mb-xl-0"
                        v-loading="loading">
            </stats-card>
          </router-link>
        </div>
        <div class="col-xl-3 col-lg-6">
          <router-link :to="{ path: '/followers'}">
          <stats-card :title="variables.get('follower')"
                      cardBg="bg-vg-yellow"
                      :sub-title="statistics.followerCount.toString()"
                      icon="fa fa-user-plus"
                      class="mb-4 mb-xl-0"
                      v-loading="loading">
          </stats-card>
          </router-link>
        </div>
        <div class="col-xl-3 col-lg-6">
          <router-link :to="{ path: '/posts'}">
          <stats-card :title="variables.get('post')"
                      cardBg="bg-vg-blue"
                      :sub-title="statistics.postCount.toString()"
                      icon="ni ni-like-2"
                      class="mb-4 mb-xl-0"
                      v-loading="loading">
          </stats-card>
          </router-link>
        </div>
      </div>
    </base-header>

    <!--Grafik ve son başvurular-->
    <div class="container-fluid">
      <div class="row mt-5">

        <div class="col-xl-5 mb-xl-0">
          <follower-charts></follower-charts>
        </div>
        <div class="col-xl-7">
          <last-applications-table></last-applications-table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {variables} from "../langs/tr";
import * as axios from "axios";
import LastApplicationsTable from "@/views/Home/LastApplicationsTable";
import FollowerCharts from "@/views/Home/FollowerCharts";

export default {
  components: {
    FollowerCharts,
    LastApplicationsTable
  },
  data() {
    return {
      statistics: {
        allJobCount: 0,
        applicationCount: 0,
        followerCount: 0,
        postCount: 0
      },
      loading: true,
      variables
    };
  },
  created() {
    this.getStats();
  },
  methods: {
    getStats() {
      axios.get('company/statistics').then(response => {
        this.statistics = response.data;
        this.loading = false;
      })
    },
  }
};
</script>
<style scoped>
@import "../assets/css/custom.css";
.el-loading-mask{
  z-index: 0!important;
}
</style>
